import { routes as constantRoutes } from '@/router'
import { getRouters } from '@/api/menu'
import Layout from '@/layout/index'
const permission = {
  state: {
    routes: [],
    addRoutes: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        // 向后端请求路由数据
        getRouters().then(res => {
          console.log(res,777777)
          let a
          let b
          let c
          let d
          // let e
          let cb
          res.data.forEach((item,index)=>{
            if (item.meta.title=='单位信息'){
              a=res.data.splice(index,1)
            }
          })
          res.data.forEach((item,index)=>{
            if (item.meta.title=='档案管理'){
              b=res.data.splice(index,1)
            }
          })
          res.data.forEach((item,index)=>{
            if (item.meta.title=='文旅巡查'){

              c=res.data.splice(index,1)
            }
          })
          res.data.forEach((item,index)=>{
            if (item.meta.title=='数据分析'){
              res.data[index].children.forEach((i,t)=>{
                if (i.meta.title=="智慧消防数据分析") {
                  i.meta.title="大屏展示"
                }
              })
              // d=res.data.splice(index,1)
              // d[0]
            }
          })
          // res.data.forEach((item,index)=>{
          //   if (item.meta.title=='电子预案'){

          //     e=res.data.splice(index,1)
          //   }
          // })
          if (b) {

            b[0].children.forEach((i,t)=>{
              if (i.meta.title=="消防档案管理") {
                i.meta.title="消防档案"
                cb=b[0].children.splice(i,1)
              }
            })
          }
          
       
          if (a) {
            res.data.splice(0,0,a[0])
          }
          if (b) {
            res.data.splice(1,0,b[0])
          }
          if (c) {
            res.data.splice(2,0,c[0])
          }
          
          

          // res.data.splice(3,0,d[0])
          // res.data.splice(4,0,d[0])
          res.data.forEach((item,index)=>{
            if (item.meta.title=='单位信息'&&cb){
              item.children.push(cb[0])
            }
          })

          console.log(a,b,c,d,cb,111111);
          res.data.forEach((item,index) => {
            if (item.meta.title=='单位信息') {
              item.meta.title='消防信息'
              item.children[0].meta.title='消防信息'
            }
            if (item.meta.title=='文旅巡查') {
              item.meta.title='文物巡查'
            }
            if (item.meta.title=='档案管理') {
              item.meta.title='文物档案'
            }
          });
          const accessedRoutes = filterAsyncRouter(res.data)
          accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', accessedRoutes)
          resolve(accessedRoutes)
        })
      })
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    if (route.path.charAt(0) !== '/') {
      route.path = '/' + route.path
    }

    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'Layout') {
        route.component = {
          render: c => c("router-view")

        }
      } else {
        route.component = loadView(route.component)
      }

    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
}

export const loadView = (view) => { // 路由懒加载
  return (resolve) => require([`@/views/${view}`], resolve)
}

export default permission
